import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-Developer-Seeds', [
  'heading',
  'submitButton',
  'form',
  'unavailableBanner',
]);
